import {toListItemDateString, toListItemDateString1} from "@/utils/dateUtils";
import RpIcon from "@/components/RpIcon";
import {getIconByBizType, getResourceByMcc, getResourceByMccName} from "@/utils/utils";
import {AssetTransItemType} from "./AssetsTransDetail.tsx";
import {useTranslation} from "react-i18next";
import useRenders from '@/hook/useRenders'
import {createStyles, Stack, Box, Typography} from "@mui/material";
import classes from './transItem.module.css'

export default function AssetsTransItem({record}: { record: AssetTransItemType }) {

  const {t} = useTranslation("translation");

  const {renderAssetLogStatus} = useRenders();

  const _isCardTrans = () => {
    return !!record.cardId;
  }

  const _transTile = () => {
    if (!record) return null;
    return <Stack direction="row" alignItems="center">
      {_renderIcon(true)}
      <Box>
        <Typography color="textColor">Withdraw</Typography>
        <Typography color="secondaryTextColor">{
          toListItemDateString1(record.createTime)
          // `\u2022\u2022\u2022\u2022 ${record.cardLast4}`
        }</Typography>
      </Box>
    </Stack>
  }

  const _getCardTrans = () => {
    if (_isCardTrans() && record.isRefund === 1) {
      return <div className="text-primary-main">{t('is_refund')}</div>
    } else {
      return <></>;
    }

  }

  const _renderIcon = (isCardTrans: boolean) => {
    if (isCardTrans) {
      let icon = getResourceByMccName(record.merchantName);
      const merchantIcon = icon != null;
      if (!icon) icon = getResourceByMcc(record.mcc);
      let iconEl;
      if (icon) {
        iconEl = <img className="w-[24px] h-[24px]" src={icon}/>
      } else {
        iconEl = <RpIcon icon={"plus"} size={18}/>
      }

      return merchantIcon ?
        <div className="me-4 p-2">
          {iconEl}
        </div> :
        <div className="me-4 p-2 bg-hover-bg dark:bg-hover-bg-dark flex justify-center items-center rounded-full ">
          {iconEl}
        </div>;
    } else {
      const icon = getIconByBizType(record.businessType);
      return <Stack>
        <RpIcon icon={icon ?? 'card-info'} size={18}/>
      </Stack>
    }
  }

  const getRightContent = () => {
    return (
      <Stack direction="column">
        <Typography>{record.amount} {record.varietyCode?.toUpperCase()}</Typography>
        <Typography>
          {_getCardTrans()}
        </Typography>
        <Typography textAlign="right" color="textSecondary">{
          renderAssetLogStatus(record.status)
          // toListItemDateString(record.createTime)
        }</Typography>
      </Stack>
    )
  }

  if (!record) return null;

  return <Box className={classes.root}>
    <Stack className={classes.content} direction="row">
      <Stack direction="row" alignItems="center">
        {_transTile()}
      </Stack>
      <Box>
        {getRightContent()}
      </Box>
    </Stack>
  </Box>;
}